import { render, staticRenderFns } from "./PosReceiptPreview.vue?vue&type=template&id=875673e6&"
import script from "./PosReceiptPreview.vue?vue&type=script&lang=js&"
export * from "./PosReceiptPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports